import { CancelTokenSource } from "axios";
import { MutationTree } from "vuex";
import { RefreshGridMode } from "@/models/leads/ContactForm";
import { DataSourceResult } from "@/models/DataSourceResult";
import { FilterCollection } from "@/models/FilterCollection";
import { GridColumn } from "@/models/GridColumn";
import { MetadataMaskyooStatus } from "@/models/MetadataMaskyooStatus";
import { ChannelMultiselectItem, MultiselectItem } from "@/models/MultiselectItem";
import { PhoneStatus, PhoneWithChannel } from "@/models/phones/PhoneWithChannel";
import { TableSettings } from "@/models/TableSettings";
import { PhoneLeadStats } from "@/models/leads/LeadStatistic";
import { PhonesPageData } from "@/models/phones/PhonesPageData";
import { PhonesState } from "@/models/states/PhonesState";

const mutations: MutationTree<PhonesState> = {
  setCancelTokenSource(state: PhonesState, cancelTokenSource: CancelTokenSource) {
    state.cancelTokenSource = cancelTokenSource;
  },

  setChannels(state: PhonesState, channels: ChannelMultiselectItem[]) {
    state.channels = channels;
  },

  setClients(state: PhonesState, clients: MultiselectItem[]) {
    state.clients = clients;
  },

  setColumns(state: PhonesState, columns: GridColumn[]) {
    state.columns = columns;
  },

  setColumnsFilters(state: PhonesState, columnsFilters: FilterCollection) {
    state.columnsFilters = columnsFilters;
  },

  setDatePeriod(state: PhonesState, datePeriod: Date[]) {
    state.datePeriod = datePeriod;
  },

  setNeedToRefreshPhonesGrid(state: PhonesState, needToRefreshPhonesGrid: RefreshGridMode) {
    state.needToRefreshPhonesGrid = needToRefreshPhonesGrid;
  },

  setPage(state: PhonesState, page: number) {
    state.page = page;
  },

  setPhoneLeadStats(state: PhonesState, phoneLeadStats: PhoneLeadStats) {
    state.phoneLeadStats = phoneLeadStats;
  },

  setPhones(state: PhonesState, phones: DataSourceResult) {
    state.phones = phones;
  },

  setPhonesPageData(state: PhonesState, phonesPageData: PhonesPageData) {
    state.phonesPageData = phonesPageData;
  },

  setSearchValue(state: PhonesState, searchValue: string) {
    state.searchValue = searchValue;
  },

  setSelectedCallStatus(state: PhonesState, selectedCallStatus?: MetadataMaskyooStatus) {
    state.selectedCallStatus = selectedCallStatus;
  },

  setSelectedChannelMetadataTypesIds(state: PhonesState, selectedChannelMetadataTypesIds: number[]) {
    state.selectedChannelMetadataTypesIds = selectedChannelMetadataTypesIds;
  },

  setSelectedClientsIds(state: PhonesState, selectedClientsIds: number[]) {
    state.selectedClientsIds = selectedClientsIds;
  },

  setSelectedPhone(state: PhonesState, selectedPhone?: PhoneWithChannel) {
    state.selectedPhone = selectedPhone;
  },

  setSelectedPhonesGridColumnsIds(state: PhonesState, selectedPhonesGridColumnsIds: number[]) {
    state.selectedPhonesGridColumnsIds = selectedPhonesGridColumnsIds;
  },

  setSelectedPhoneStatus(state: PhonesState, selectedPhoneStatus?: PhoneStatus) {
    state.selectedPhoneStatus = selectedPhoneStatus;
  },

  setSelectedSourcesIds(state: PhonesState, selectedSourcesIds: string[]) {
    state.selectedSourcesIds = selectedSourcesIds;
  },

  setShowGraphs(state: PhonesState, showGraphs: boolean) {
    state.showGraphs = showGraphs;
  },

  setSortDir(state: PhonesState, sortDir: string) {
    state.sortDir = sortDir;
  },

  setSortField(state: PhonesState, sortField: string) {
    state.sortField = sortField;
  },

  setSources(state: PhonesState, sources: ChannelMultiselectItem[]) {
    state.sources = sources;
  },

  setTableSettings(state: PhonesState, tableSettings: TableSettings) {
    state.tableSettings = tableSettings;
  },
};
export default mutations;
